import { useEffect } from 'react';
import { WebSiteSchema, OrganizationSchema } from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import VideoGridSection from './components/VideoGridSection';
import ArticleSection from './components/ArticleSection';
import AboutSection from './components/AboutSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    document.title = '91视频网站 - 在线视频平台 | 视频资源大全 | 热门视频导航与内容观看入口';
  }, []);

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '91视频网站首页',
    description: '91视频网站首页，汇聚在线视频平台资源与视频大全，提供热门视频导航和内容观看入口。',
    url: 'http://ewqivah.cn/',
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '电影大片', url: 'http://ewqivah.cn/category/movie' },
        { '@type': 'ListItem', position: 2, name: '电视剧集', url: 'http://ewqivah.cn/category/tv' },
        { '@type': 'ListItem', position: 3, name: '综艺节目', url: 'http://ewqivah.cn/category/variety' },
        { '@type': 'ListItem', position: 4, name: '动漫动画', url: 'http://ewqivah.cn/category/anime' },
        { '@type': 'ListItem', position: 5, name: '纪录片', url: 'http://ewqivah.cn/category/documentary' },
        { '@type': 'ListItem', position: 6, name: '音乐MV', url: 'http://ewqivah.cn/category/music' },
      ],
    },
  };

  return (
    <main>
      <WebSiteSchema />
      <OrganizationSchema />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageSchema) }} />

      <HeroSection />
      <CategorySection />
      <VideoGridSection />
      <ArticleSection />
      <AboutSection />
      <TestimonialSection />
      <CTASection />
    </main>
  );
}